import { Flex } from "@mantine/core";
import CreateRuleModal from "./CreateRuleModal";
import IconSearch from "@tabler/icons-react/dist/esm/icons/IconSearch.mjs";
import { useDispatch } from "react-redux";
import {
  setRulesFilters,
  useSelectFiltersRules,
  useSelectSortRules,
} from "../../../redux/features/rules/rulesSlice";
import ExportBtn from "../../../components/exportBtn/exportBtn";
import { urlSearchParamsBuilder } from "../../../utils/functions";
import ThrottledTextInput from "../../../components/ThrottledTextInput";

const RuleActions = () => {
  const dispatch = useDispatch();
  const filters = useSelectFiltersRules();
  const sort = useSelectSortRules();
  const q = filters.filters?.q;

  const handleSearch = async (val) => {
    dispatch(setRulesFilters({ q: val }));
  };

  const searchQuery = urlSearchParamsBuilder({
    ...sort,
    ...filters,
  });

  return (
    <Flex
      bg="gray.3"
      justify="space-between"
      align="center"
      pl="md"
      pr="md"
      pt="sm"
      pb="sm"
    >
      <Flex align="center" gap="lg">
        <CreateRuleModal />
        <ExportBtn
          exportUrl={`rule/all/export?${searchQuery}`}
          method="GET"
          name={"rules"}
        />
      </Flex>
      <ThrottledTextInput
        onThrottledChange={(e) => handleSearch(e)}
        placeholder="Search"
        value={q}
        w={200}
        leftSection={<IconSearch size="1rem" />}
      />
    </Flex>
  );
};

export default RuleActions;
